@if (authService.currentUser() !== null) {
  <tlm-main-layout />
} @else {
  <tlm-full-screen-spinner />
}
